export default {
  navContainer: ({ props }) => ({
    class: [
      // Position
      'relative',

      // Misc
      { 'overflow-hidden': props.scrollable },
    ],
  }),
  navContent: {
    class: [
      // Overflow and Scrolling
      'overflow-y-hidden overscroll-contain',
      'overscroll-auto',
      'scroll-smooth',
      '[&::-webkit-scrollbar]:hidden',
    ],
  },
  previousButton: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',

      // Position
      '!absolute',
      'top-0 left-0',
      'z-20',

      // Size and Shape
      'h-full w-12',
      'rounded-none',

      // Colors
      'bg-surface-0 dark:bg-surface-800',
      'text-primary-500 dark:text-primary-400',
      'shadow-md',
    ],
  },
  nextButton: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',

      // Position
      '!absolute',
      'top-0 right-0',
      'z-20',

      // Size and Shape
      'h-full w-12',
      'rounded-none',

      // Colors
      'bg-surface-0 dark:bg-surface-800',
      'text-primary-500 dark:text-primary-400',
      'shadow-md',
    ],
  },
  nav: {
    class: [
      // Flexbox
      'flex flex-1 gap-2',

      // Spacing
      'list-none',
      'm-0 pl-6',
      'border-b border-surface-200',

      // Colors
      'bg-surface-0 dark:bg-surface-900',
      'text-surface-900 dark:text-surface-400',
    ],
  },
  tabpanel: {
    header: ({ props }) => ({
      class: [
        // Spacing
        // 'mr-[-24px] ml-6',

        // Misc
        {
          'opacity-60 cursor-default user-select-none select-none pointer-events-none':
            props?.disabled,
        },
      ],
    }),
    headerAction: ({ parent, context }) => ({
      class: [
        'relative',

        // Font
        'font-medium text-sm',

        // Flexbox and Alignment
        'flex items-center',

        // Spacing
        'py-2 px-1',
        '-mb-[2px]',
        'h-full',

        // Shape
        'border-b-[2.5px]',
        'rounded-t-md',

        // Colors and Conditions
        {
          'border-transparent dark:border-transparent':
            parent.state.d_activeIndex !== context.index,
          // 'bg-surface-0 dark:bg-surface-800':
          //   parent.state.d_activeIndex !== context.index,
          'text-surface-500 dark:text-surface-400':
            parent.state.d_activeIndex !== context.index,
          'font-medium': parent.state.d_activeIndex !== context.index,

          // 'bg-surface-0 dark:bg-surface-800':
          //   parent.state.d_activeIndex === context.index,
          'border-primary-500 dark:border-primary-500':
            parent.state.d_activeIndex === context.index,
          'text-primary-900 dark:text-white':
            parent.state.d_activeIndex === context.index,
          'font-semibold': parent.state.d_activeIndex === context.index,
        },

        // States
        'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset',
        'focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',
        {
          // 'hover:bg-surface-0 dark:hover:bg-surface-800/50':
          //   parent.state.d_activeIndex !== context.index,
          // 'hover:border-surface-400 dark:hover:border-primary-400':
          //   parent.state.d_activeIndex !== context.index,
          'hover:text-surface-700 dark:hover:text-white':
            parent.state.d_activeIndex !== context.index,
        },

        // Transitions
        'transition-all duration-200',

        // Misc
        'cursor-pointer select-none text-decoration-none',
        'overflow-hidden',
        'user-select-none',
      ],
    }),
    headerTitle: {
      class: [
        // Text
        // 'leading-none',
        'whitespace-nowrap',
      ],
    },
    content: {
      class: [
        // Spacing
        // 'p-5',

        // Shape
        // 'rounded-b-md',

        // Colors
        // 'bg-surface-0 dark:bg-surface-800',
        // 'text-surface-700 dark:text-surface-0/80',
        'border-0',
      ],
    },
  },
}
